import setting from '@/config';
import axios from 'axios';
import { Loading, Message } from 'element-ui';
import Qs from 'qs';

const baseURL = window.location.host.indexOf('localhost') >= 0 ? setting.API_URL : './'

const api = axios.create({
    baseURL: baseURL,
    timeout: 20000,
    responseType: 'json'
        // withCredentials: true
})

api.interceptors.request.use(
    config => {
        if (config.method != 'post' && config.method != 'get') {
            config.method = 'post';
        }
        if (typeof config.url == 'string' && config.url.indexOf('http') < 0) {
            if (config.url.substring(0, 1) === '/') {
                config.url = config.baseURL + config.url.split('/', 2)[1]
            } else {
                config.url = config.baseURL + config.url
            }
        }

        let data = {};
        //设置加载状态 把Loading实例放在config里面 放在api里面会导致多个请求时冲突
        config.loadingInstance = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: "rgba(228, 228, 228, 0.1)",
            customClass: "osloading",
            fullscreen: false
        })
        if (config.method == 'post') {
            config.data = Qs.stringify(config.data)
        }
        return config
    }
)

api.interceptors.response.use(
    response => {
        //清除加载状态
        if (typeof response.config.loadingInstance == 'object') {
            response.config.loadingInstance.close();
        }
        if (response.status == 200) {
            if (response.data.code != 200) {
                return Promise.resolve(response.data)
            }
            return Promise.resolve(response.data)
        }
        return Promise.resolve({ 'code': 500, 'msg': '请求打开失败,请稍后再试~' })
    },
    error => {
        //清除加载状态
        if ('object' === typeof error.config && typeof error.config.loadingInstance == 'object') {
            error.config.loadingInstance.close();
        }
        Message.error('服务端出现错误，' + error)
        return Promise.reject(error)
    }
)
export default api


// WEBPACK FOOTER //
// ./src/api/index.js